import { OfflineOrderingState } from '../types';

const addItemByInput = (state: OfflineOrderingState, tempId: string, value: string): OfflineOrderingState => {
  if (Number(value) === 0) {
    return {
      ...state,
      menus: state.menus.filter((x) => x.tempId !== tempId),
    };
  }
  return {
    ...state,
    menus: state.menus.map((item) => {
      if (item.tempId === tempId) {
        return {
          ...item,
          count: parseInt(value, 10),
          orderItemToppings: item?.orderItemToppings?.map((x) => ({
            ...x,
            count: parseInt(value, 10),
          })),
        };
      }
      return item;
    }),
  };
};

export default addItemByInput;
